import { Component, ViewChild } from '@angular/core';
import { IonicPage, ViewController, Platform, NavParams } from 'ionic-angular';
import { StorageProvider } from '../../providers/storage/storage';
import { StorageType } from '../../model/types/storage-type';
import { SegmentProvider } from '../../providers/analytics/segment';
import { BranchProvider } from '../../providers/analytics/branch';
import { AnalyticsEventType } from '../../model/types/analytics.const';
import { TranslateService } from '@ngx-translate/core';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { DeviceProvider } from '../../providers/device';
import { NotificationProvider } from '../../providers/notification/notification';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { PermissionProvider } from '../../providers/myria/permission-provider';
import { CustomerProvider } from '../../providers/customer/customer';
import { APP_CONFIG } from '../../environment';
import { RouteProvider } from '../../providers/route/route';

export enum PermissionType {
  ATT = 'ATT',
  LOCATION = 'LOCATION',
  NOTIFICATION = 'NOTIFICATION'
}
interface PermissionItem {
  icon?: String;
  title?: String;
  description?: String;
}
@IonicPage()
@Component({
  selector: 'permission-tracking',
  templateUrl: 'permission-tracking.html'
})
export class PermissionTrackingPage {
  @ViewChild('language') language;

  paymentMethods;
  title: String;
  headerImg: String;
  description: String;
  itemsTitle: String;
  items: PermissionItem[]
  closingText: String;
  primaryActionButtonText: String;
  secondaryActionButtonText: String;
  showSecondaryButton: boolean = false;
  permissionType;
  onDismiss: any;

  constructor(
    private storageProvider: StorageProvider,
    private analytics: SegmentProvider,
    private viewCtrl: ViewController,
    private branch: BranchProvider,
    private platform: Platform,
    private translate: TranslateService,
    private utilsProvider: UtilsProvider,
    private navParams: NavParams,
    private deviceProvider: DeviceProvider,
    private notification: NotificationProvider,
    private routeProvider: RouteProvider,
    private permissionProvider: PermissionProvider,
    private customerProvider: CustomerProvider
  ) {
    this.permissionType = this.navParams.get('permissionType');
    this.onDismiss = this.navParams.get('onDismiss');
    this.updateContent();
  }

  updateContent() {

    if (this.permissionType === PermissionType.ATT) {
      this.headerImg = "assets/img/permission-tracking/att_header.svg"
      // on IOS according to the guidelines
      if (this.platform.is('ios'))
        this.primaryActionButtonText = this.translate.instant('global.genericContinueButton');
      else {
        this.showSecondaryButton = this.utilsProvider.isConsentModeEnabled();
        this.primaryActionButtonText = this.translate.instant((this.showSecondaryButton) ? 'global.acceptButton' : 'global.genericContinueButton')
        this.secondaryActionButtonText = this.translate.instant('global.rejectButton');
      }

      this.title = this.translate.instant('global.myRia.jsonContent.personalizationTitle');
      this.description = this.translate.instant('global.myRia.jsonContent.personalizationDescription');
      this.itemsTitle = this.translate.instant("global.myRia.jsonContent.personalizationBenefitsTitle")
      this.items = [
        {
          icon: "assets/img/permission-tracking/idea.svg",
          title: "",
          description: this.translate.instant('global.myRia.jsonContent.personalizationBenefitsItem1')
        },
        {
          icon: "assets/img/permission-tracking/rocket-outline.svg",
          title: "",
          description: this.translate.instant('global.myRia.jsonContent.personalizationBenefitsItem2'),
        }
      ];
      this.closingText = this.translate.instant('global.myRia.jsonContent.personalizationBenefitsFooter')

    } else if (this.permissionType === PermissionType.LOCATION) {
      this.headerImg = "assets/img/permission-tracking/location_pin.svg"
      // on IOS according to the guidelines
      if (this.platform.is('ios'))
        this.primaryActionButtonText = this.translate.instant('global.genericContinueButton');
      else {
        this.showSecondaryButton = true;
        this.primaryActionButtonText = this.translate.instant('global.myRia.jsonContent.locationButtonAllow');
        this.secondaryActionButtonText = this.translate.instant('global.myRia.jsonContent.notificationsButtonNotNow');
      }
      this.title = this.translate.instant('global.myRia.jsonContent.locationTitle')
      this.description = this.translate.instant('global.myRia.jsonContent.locationDescription')
      this.itemsTitle = this.translate.instant('global.myRia.jsonContent.locationBenefitsTitle')
      this.items = [
        {
          icon: "assets/img/permission-tracking/store.svg",
          title: this.translate.instant('global.myRia.jsonContent.locationBenefitsItem1'),
          description: this.translate.instant('global.myRia.jsonContent.locationBenefitsItem1-2')
        },
        {
          icon: "assets/img/permission-tracking/ibm-security.svg",
          title: this.translate.instant('global.myRia.jsonContent.locationBenefitsItem2'),
          description: this.translate.instant('global.myRia.jsonContent.locationBenefitsItem2-2')
        }
      ];

    } else if (this.permissionType === PermissionType.NOTIFICATION) {
      this.headerImg = "assets/img/permission-tracking/noti_bell_header.svg"
      this.primaryActionButtonText = this.translate.instant('global.genericContinueButton');
      this.secondaryActionButtonText = this.translate.instant('global.myRia.jsonContent.notificationsButtonNotNow');
      this.title = this.translate.instant('global.myRia.jsonContent.notificationsTitle')
      this.description = this.translate.instant('global.myRia.jsonContent.notificationsDescription')
      this.itemsTitle = this.translate.instant('global.myRia.jsonContent.notificationsBenefitsTitle')
      this.items = [
        {
          icon: "assets/img/permission-tracking/event-schedule.svg",
          title: this.translate.instant('global.myRia.jsonContent.notificationsBenefitsItem1'),
          description: this.translate.instant('global.myRia.jsonContent.notificationsBenefitsItem1-2')
        },
        {
          icon: "assets/img/permission-tracking/document-add.svg",
          title: this.translate.instant('global.myRia.jsonContent.notificationsBenefitsItem2'),
          description: this.translate.instant('global.myRia.jsonContent.notificationsBenefitsItem2-2')
        },
        {
          icon: "assets/img/permission-tracking/gift.svg",
          title: this.translate.instant('global.myRia.jsonContent.notificationsBenefitsItem3'),
          description: this.translate.instant('global.myRia.jsonContent.notificationsBenefitsItem3-2')
        }
      ];
    }
  }

  async continue() {
    if (this.platform.is('cordova')) {
      if (this.permissionType === PermissionType.ATT) {
        if (this.showSecondaryButton) { //Merging changes from OM-10360
          this.analytics.trackEvent({
            eventName: AnalyticsEventType.ConsentOptionSelected, analyticsData:
              { opt: "in", ad_user_data: true, ad_personalization: true, analytics: true, marketing: true }
          });
        }
        this.permissionProvider.requestATTPermission().then(() => {
          this.dismiss();
        })
      } else if (this.permissionType === PermissionType.LOCATION) {
        this.permissionProvider.requestLocationPermission().then((response)=>{
          LoggerProvider.info(this, 'Location Fetched successfully', response);
          this.dismiss();
        })
      } else if (this.permissionType === PermissionType.NOTIFICATION) {
        try {
          const response = await this.permissionProvider.requestNotificationPermission()
          LoggerProvider.info(this, 'Registered successfully for Remote Notifications', response)
        } catch(ex) {
          LoggerProvider.error(this, LoggerEvent.GeneralException, "Erorr occured while waiting to register for notification");
        }
        this.dismiss()
      }
    } else {
      switch (this.permissionType) {
        case PermissionType.ATT:
          this.storageProvider.set(StorageType.ConsentIDFA, 'false');
          this.storageProvider.set(StorageType.ConsentIDFAPermission, 'true');
          break;
        case PermissionType.LOCATION:
          this.storageProvider.set(StorageType.LocationAccess, 'true');
          break;
        case PermissionType.NOTIFICATION:
          this.storageProvider.set(StorageType.NotificationAccess, 'true');
          break;
        default:
          break;
      }
      this.dismiss();
    }
  }

  dismiss() {
    this.routeProvider.modalDismiss(this.viewCtrl, this.navParams);
    if (this.onDismiss) {
      this.onDismiss();
    }
  }

  reject() {
    if (this.permissionType == PermissionType.ATT) {
      this.storageProvider.set(StorageType.ConsentIDFA, 'false');
      this.storageProvider.set(StorageType.ConsentIDFAPermission, 'false');
      this.analytics.trackEvent({
        eventName: AnalyticsEventType.ConsentOptionSelected, analyticsData:
          { opt: "out", ad_user_data: false, ad_personalization: false, analytics: false, marketing: false }
      });
    }else if(this.permissionType == PermissionType.LOCATION) {
      // If user has accesseed this permission screen then we don't need to show this again.
      this.storageProvider.set(StorageType.LocationAccess, 'true');
    }else if(this.permissionType == PermissionType.NOTIFICATION) {
      // If user has accesseed this permission screen then we don't need to show this again.
      this.storageProvider.set(StorageType.NotificationAccess, 'true');
    }    


    this.dismiss();
  }

  selectLanguage(lang) {
    this.analytics.trackEvent({
      eventName: AnalyticsEventType.LanguageSelected, analyticsData: {
        location: 'Permission Tracking screen',
        language: lang,
      }
    });

    this.customerProvider.setLanguage(lang).then(()=>{
      this.language.update();
      this.updateContent();
    });  
  }

  allowTrackingTerms() {
    if(APP_CONFIG.region.isEu)
      return this.translate.instant('global.allowTrackingTermsEU');
    else
      return this.translate.instant('global.allowTrackingTerms');
  }
}


// WEBPACK FOOTER //
// ./src/pages/permission-tracking/permission-tracking.ts